// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "web-gift-cards-" + chunkId + "-26-19-1.js";
};